import { CompanySearchResultEntry, GeneralDetailResult } from '../../../../generated/model/models';

export enum CompanyContextActionTypes {
  SetInitial = 'filters/SET_COMPANIES_INITIAL_STATE',
  SetCompanies = 'filters/SET_COMPANIES_STATE',
  SetCompany = 'filters/SET_COMPANY_STATE',
  SetPagination = 'filters/SET_PAGINATION_STATE',
  ResetPagination = 'filters/RESET_PAGINATION_STATE',
  SelectCompanies = 'filters/SET_SELECTED_COMPANIES_STATE',
  SelectFiles = 'filters/SET_SELECTED_FILES_STATE',
  SetFilterButtonClickState = 'filters/SET_FILTER_BUTTON_CLICK_STATE',
  SetIsLoadingState = 'filters/SET_IS_LOADING_STATE',
  SetCompanyGeneralInfo = 'tabs/SET_COMPANY_GENERAL_INFO',
  SetClickedCompanyTabName = 'tabs/SET_CLICKED_COMPANY_TAB_NAME',
  SetDatasetInfo = 'companies/SET_DATASET_INFO',
}

export type CompanyContextActions =
  | { type: CompanyContextActionTypes.SetInitial; payload: string }
  | { type: CompanyContextActionTypes.SetCompanies; payload: SearchCompaniesInterface }
  | { type: CompanyContextActionTypes.SetCompany; payload: CompanySearchResultEntry | undefined }
  | { type: CompanyContextActionTypes.SetPagination; payload: PaginationStateInterface }
  | { type: CompanyContextActionTypes.ResetPagination }
  | { type: CompanyContextActionTypes.SelectCompanies; payload: SelectedCompaniesStateInterface }
  | { type: CompanyContextActionTypes.SelectFiles; payload: SelectedFilesStateInterface }
  | { type: CompanyContextActionTypes.SetFilterButtonClickState; payload: boolean }
  | { type: CompanyContextActionTypes.SetIsLoadingState; payload: boolean }
  | { type: CompanyContextActionTypes.SetCompanyGeneralInfo; payload: GeneralDetailResult }
  | { type: CompanyContextActionTypes.SetClickedCompanyTabName; payload: string }
  | {
      type: CompanyContextActionTypes.SetDatasetInfo;
      payload: { dataset?: string; dbVersion?: string };
    };

export type CompaniesProps = {
  companies: CompanySearchResultEntry[];
  searchId?: string;
  dataset?: string;
  dbVersion?: string;
  company?: CompanySearchResultEntry;
  pagination: PaginationStateInterface;
  selectedCompanies: SelectedCompaniesStateInterface;
  selectedFiles: SelectedFilesStateInterface;
  filterButtonClickState: boolean;
  companyGeneralInfo?: GeneralDetailResult;
  clickedCompanyTabName: string;
  isLoading: boolean;
};

export interface PaginationStateInterface {
  page: number;
  size: number;
  totalPages: number;
  totalElements: number;
}

export interface SearchCompaniesInterface {
  searchId: string;
  dataset: string;
  dbVersion?: string;
  companies: CompanySearchResultEntry[];
}

export type SelectedCompaniesStateInterface = string[];
export type SelectedFilesStateInterface = string[];

export type CompaniesProviderProps = { children: React.ReactNode };
